<div [nTooltip]="settingsDropdown"
    [nTooltipOverlayClass]="isSmallSize ? ['header-tip', 'small-size'] : ['header-tip']"
    [nTooltipPlacement]="isSmallSize ? 'leftTop' : 'bottom'"
    nTooltipTrigger="click"
    nTooltipTheme="black"
    [(nTooltipVisible)]="tooltipVisible"
    id="header-seetings">
    <svg class="icon header-icon">
        <use xlink:href="#app-icon-header-setting"></use>
    </svg>
</div>

<ng-template #settingsDropdown>
    <div class="header-tip-box">
        <ul>
            <li *ngFor="let item of items"
                [class.divide]="item.divide"
                (click)="item.command()">
                {{ item.label }}
            </li>
        </ul>
    </div>
</ng-template>
